<template>
  <span >
    <audio :key="src" ref="audio" @durationchange="duration = $refs.audio ? Math.floor($refs.audio.duration) : 'Infinite'" @timeupdate="time = $refs.audio ? Math.floor($refs.audio.currentTime) : 0" @pause="() => {if ($refs.audio) $refs.audio.currentTime = 0}" @ended="playing = false" :autoplay="autoplay">
      <source :src="src" type="audio/mpeg">
      Your browser does not support the audio element.
    </audio>

    <b-button-group v-bind="$attrs" v-on="$listeners" v-if="loading">
      <b-button key="loading"><span class="far fa-spinner fa-spin"></span></b-button>
      <!-- <b-button disabled><span v-if="duration">{{duration}}s</span></b-button> -->
    </b-button-group>

    <b-button-group v-bind="$attrs" v-on="$listeners" v-else-if="!playing">
      <b-button key="play" @click="play" ><i class="fas fa-play" ></i></b-button>
      <!-- <b-button disabled><span v-if="duration">{{duration}}s</span></b-button> -->
    </b-button-group>
    <b-button-group v-bind="$attrs" v-on="$listeners" v-else-if="playing">
      <b-button key="pause" @click="pause"><i class="fas fa-pause" ></i></b-button>
      <!-- <b-button disabled>{{time}}s / {{duration}}s</b-button> -->
    </b-button-group>

  </span>
</template>

<script>

export default {
  props: {
    source: {
      type: String,
      required: false
    },
    do_before: {
      type: Function
    },
    autoplay: {
      default: false
    }
  },
  data() {
    return {
      playing: this.autoplay,
      time: 0,
      src: this.source,
      duration: undefined,
      loading: false
    }
  },
  methods: {
    async play() {
      if (this.do_before) {
        this.loading = true
        await this.do_before()
        this.loading = false
      }

      this.playing = true
      if (this.$refs.audio) {
        this.$refs.audio.play()
      }
    },
    pause() {
      this.playing = false
      if (this.$refs.audio) {
        this.$refs.audio.pause()
      }
    }
  }
}
</script>

<style>

</style>
